// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <div className="wd-prefooter">
        <div className="container wd-entry-content">
          {/* Pre-footer content if any */}
        </div>
      </div>
      <footer className="wd-footer footer-container">
        <div className="container main-footer wd-entry-content">
          {/* The footer content from Elementor post 305 */}
          <div data-elementor-type="wp-post" data-elementor-id="305" className="elementor elementor-305">
            <section
              className="wd-negative-gap elementor-section elementor-top-section elementor-element elementor-element-1b402af3 wd-section-stretch elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="1b402af3" data-element_type="section" data-settings='{"background_background":"classic"}'
            >
              <div className="elementor-container elementor-column-gap-default">
                <div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-3c95553a color-scheme-light" data-id="3c95553a" data-element_type="column">
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div className="elementor-element elementor-element-e10fa6b wd-width-100 elementor-widget elementor-widget-wd_title" data-id="e10fa6b" data-element_type="widget" data-widget_type="wd_title.default">
                      <div className="elementor-widget-container">
                        <div className="title-wrapper wd-set-mb reset-last-child wd-title-color-default wd-title-style-default wd-title-size-default text-center">
                          <div className="liner-continer">
                            <h4 className="woodmart-title-container title wd-fontsize-l">IMW_EDU.</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="elementor-element elementor-element-166949f4 elementor-widget elementor-widget-wd_list" data-id="166949f4" data-element_type="widget" data-widget_type="wd_list.default">
                      <div className="elementor-widget-container">
                        <ul className="wd-list color-scheme- wd-fontsize-m wd-type-without wd-style- text-center">
                          <li className="elementor-repeater-item-5a880d2">
                            <span className="wd-list-content list-content">
                              A 103, Block A, First Floor, Sector 63, Noida First Floor, Unity Building, Noida 201301
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-be88672 color-scheme-light" data-id="be88672" data-element_type="column">
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div className="elementor-element elementor-element-476a3aaa wd-width-100 elementor-widget elementor-widget-wd_title" data-id="476a3aaa" data-element_type="widget" data-widget_type="wd_title.default">
                      <div className="elementor-widget-container">
                        <div className="title-wrapper wd-set-mb reset-last-child wd-title-color-default wd-title-style-default wd-title-size-default text-center">
                          <div className="liner-continer">
                            <h4 className="woodmart-title-container title wd-fontsize-l">PHONE</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="elementor-element elementor-element-7e29f3c5 elementor-widget elementor-widget-wd_list" data-id="7e29f3c5" data-element_type="widget" data-widget_type="wd_list.default">
                      <div className="elementor-widget-container">
                        <ul className="wd-list color-scheme- wd-fontsize-m wd-type-without wd-style- text-center">
                          <li className="elementor-repeater-item-5a880d2">
                            <span className="wd-list-content list-content">+91 971 603 3340</span>
                            {/* <a href="#" className="wd-fill" aria-label="List item link"></a> */}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-402d2ec7 color-scheme-light" data-id="402d2ec7" data-element_type="column">
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div className="elementor-element elementor-element-5f9305b5 wd-width-100 elementor-widget elementor-widget-wd_title" data-id="5f9305b5" data-element_type="widget" data-widget_type="wd_title.default">
                      <div className="elementor-widget-container">
                        <div className="title-wrapper wd-set-mb reset-last-child wd-title-color-default wd-title-style-default wd-title-size-default text-left">
                          <div className="liner-continer">
                            <h4 className="woodmart-title-container title wd-fontsize-l">Quick Link</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="elementor-element elementor-element-18d6d0be elementor-widget elementor-widget-wd_list" data-id="18d6d0be" data-element_type="widget" data-widget_type="wd_list.default">
                      <div className="elementor-widget-container">
                        <ul className="wd-list color-scheme- wd-fontsize-m wd-type-without wd-style- text-left">
                          <li className="elementor-repeater-item-7853eb4">
                            <span className="wd-list-content list-content">Privacy policy</span>
                            <Link to="/privacypolicy" className="wd-fill" aria-label="List item link"></Link>
                          </li>
                          <li className="elementor-repeater-item-5a880d2">
                            <span className="wd-list-content list-content">Terms and conditions</span>
                            <Link to="/terms" className="wd-fill" aria-label="List item link"></Link>
                          </li>
                          <li className="elementor-repeater-item-31ffa55">
                            <span className="wd-list-content list-content">Refund and return policy</span>
                            <Link to="/refungpolicy" className="wd-fill" aria-label="List item link"></Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div className="wd-copyrights copyrights-wrapper wd-layout-centered">
          <div className="container wd-grid-g">
            <div className="wd-col-start reset-last-child">
              Copyright ©2025 imw-edu.com
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;